import { api } from "./api";

// DEMO MODE: authentication is bypassed entirely. The functions below preserve
// the same public surface used across the app, but no real Google Auth handshake
// happens. Any visitor is treated as the demo admin.

const DEMO_USER = {
  user_id: "demo_admin",
  email: "demo@silkmartsarees.com",
  name: "Silk Mart Admin",
  picture: null,
};

// startGoogleLogin used to redirect to Emergent's OAuth. In demo mode we simply
// route the user into the dashboard.
export function startGoogleLogin() {
  window.location.href = "/dashboard";
}

export async function exchangeSession(_sessionId) {
  // No-op in demo mode; return the demo user shape.
  return DEMO_USER;
}

export async function fetchMe() {
  // Backend always returns the demo user; keep the round-trip so protected
  // routes still validate connectivity to the API.
  try {
    const { data } = await api.get("/auth/me");
    return data;
  } catch (err) {
    // Fail-open in demo mode so the dashboard never gets blocked by network hiccups.
    console.warn("Saheli: /auth/me failed, using demo user", err);
    return DEMO_USER;
  }
}

export async function logout() {
  try {
    await api.post("/auth/logout");
  } catch (err) {
    console.warn("Saheli: logout API call failed", err);
  }
}
